export default {
  Title: 'Tham số báo cáo',
  Year: 'Năm',
  ViewReport: 'Xem báo cáo',
  ChoosePeriod: 'Chọn kỳ báo cáo',
  FromDate: 'Từ ngày',
  ToDate: 'Đến ngày',
  IsPrintAdjustMonth: 'In tháng chỉnh lý quyết toán',
  Account: 'Tài khoản',
  Inventory: 'Loại vật tư/ CCDC',
  Stock: 'Kho',
  ConfirmViewReport: 'Xem báo cáo',
};
